import request from '../utils/request';
import { API_PATHS } from './config';

const { USER } = API_PATHS;

/** 用户注册（匿名，固定 USER） */
export const register = (payload) =>
    request(USER.REGISTER, {
        method: 'POST',
        body: JSON.stringify(payload),
        skipAuthRedirect: true,
    });

/** 用户登录（匿名） */
export const login = (loginId, password) =>
    request(USER.LOGIN, {
        method: 'POST',
        body: JSON.stringify({ loginId, password }),
        skipAuthRedirect: true,
    });

/** 用户列表（超管全部，管理员仅 USER） */
export const listUsers = async () => {
    const data = await request(USER.LIST, { method: 'GET' });
    if (Array.isArray(data)) return data;
    if (data?.records) return data.records;
    if (data?.list) return data.list;
    return [];
};

export const getUserById = (id) =>
    request(`${USER.GET_BY_ID}/${id}`, { method: 'GET' });

export const createUser = (payload) =>
    request(USER.CREATE, {
        method: 'POST',
        body: JSON.stringify(payload),
    });

export const updateUser = (id, userData) =>
    request(`${USER.UPDATE}/${id}`, {
        method: 'POST',
        body: JSON.stringify(userData),
    });

export const deleteUser = (id) =>
    request(`${USER.DELETE}/${id}`, { method: 'POST' });

/** 授权管理员 USER → ADMIN（仅超管） */
export const grantAdmin = (id) =>
    request(`${USER.GRANT_ADMIN}/${id}`, { method: 'POST' });

/** 撤销管理员 ADMIN → USER（仅超管） */
export const revokeAdmin = (id) =>
    request(`${USER.REVOKE_ADMIN}/${id}`, { method: 'POST' });
